import { render, staticRenderFns } from "./BenefitsPaginator.vue?vue&type=template&id=1787eca3"
import script from "./BenefitsPaginator.vue?vue&type=script&lang=js"
export * from "./BenefitsPaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports